export class ConsoleOperation
{
    public static colors = {
        reset: '\x1b[0m',
        red: '\x1b[31m',
        green: '\x1b[32m',
        yellow: '\x1b[33m',
        blue: '\x1b[34m',
        magenta: '\x1b[35m',
        cyan: '\x1b[36m',
        white: '\x1b[37m',
    };
    static formatLogColor(message: string)
    {
        return (ConsoleOperation.colors.white + message + ConsoleOperation.colors.reset);
    }
    static formatInfoColor(message: string)
    {
        return (ConsoleOperation.colors.cyan + message + ConsoleOperation.colors.reset);
    }
    static formatTraceColor(message: string)
    {
        return (ConsoleOperation.colors.blue + message + ConsoleOperation.colors.reset);
    }
    static formatDebugColor(message: string)
    {
        return (ConsoleOperation.colors.magenta + message + ConsoleOperation.colors.reset);
    }
    static formatSuccessColor(message: string)
    {
        return (ConsoleOperation.colors.green + message + ConsoleOperation.colors.reset);
    }
    static formatWarningColor(message: string)
    {
        return (ConsoleOperation.colors.yellow + message + ConsoleOperation.colors.reset);
    }
    static formatErrorColor(message: string)
    {
        return (ConsoleOperation.colors.red + message + ConsoleOperation.colors.reset);
    }
    static log(message: string)
    {
        console.log(ConsoleOperation.formatLogColor(message));
    }
    static info(message: string)
    {
        console.info(ConsoleOperation.formatInfoColor(message));
    }
    static trace(message: string)
    {
        console.trace(ConsoleOperation.formatTraceColor(message));
    }
    static debug(message: string)
    {
        console.debug(ConsoleOperation.formatDebugColor(message));
    }
    static success(message: string)
    {
        console.info(ConsoleOperation.formatSuccessColor(message));
    }
    static warning(message: string)
    {
        console.warn(ConsoleOperation.formatWarningColor(message));
    }
    static error(message: string)
    {
        console.error(ConsoleOperation.formatErrorColor(message));
    }
}